import React from 'react';
import { Input, withStyles } from '@material-ui/core';

import Calendar from '../../../../../../../../../../components/icons/Calendar';
import styles from './styles';
import { format, isValid } from 'date-fns';
import { GLOBAL_DATE_FORMAT } from 'common/dateFormatConfig';

const Trigger = React.forwardRef(({ date, ...props }, ref) => {
  const selected = date ? new Date(date) : null;

  return (
    <Input
      {...props}
      ref={ref}
      // An unset bound falls back to the placeholder — date-fns `format` throws on an invalid date.
      value={isValid(selected) ? format(selected, GLOBAL_DATE_FORMAT.fullDateWithDay) : ''}
      readOnly
      disableUnderline={true}
      endAdornment={<Calendar />}
    />
  );
});

export default withStyles(styles)(Trigger);
